/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pages: NonNullable<unknown>, date: NonNullable<unknown> }} Scrape_Router_MetaInputs */

const en_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} pages, one try each, measured ${i?.date}`)
};

const zh_hans1_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} 个页面，每个只试一次，测于 ${i?.date}`)
};

const pt_br2_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} páginas, uma tentativa cada, medido em ${i?.date}`)
};

const es_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} páginas, un intento cada una, medido el ${i?.date}`)
};

const fr_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} pages, un essai chacune, mesuré le ${i?.date}`)
};

const de_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} Seiten, je ein Versuch, gemessen am ${i?.date}`)
};

const ru_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Страниц: ${i?.pages}, по одной попытке, замер ${i?.date}`)
};

const it_scrape_router_meta = /** @type {(inputs: Scrape_Router_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pages} pagine, un tentativo ciascuna, misurato il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{pages} pages, one try each, measured {date}" |
*
* @param {Scrape_Router_MetaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_meta = /** @type {((inputs: Scrape_Router_MetaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_MetaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_meta(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_meta(inputs)
	if (locale === "es") return es_scrape_router_meta(inputs)
	if (locale === "fr") return fr_scrape_router_meta(inputs)
	if (locale === "de") return de_scrape_router_meta(inputs)
	if (locale === "ru") return ru_scrape_router_meta(inputs)
	if (locale === "it") return it_scrape_router_meta(inputs)
	return en_scrape_router_meta(inputs)
});